import { PermissionMapping } from '@@/lib/permissions';

export type KnowledgeManagementPermission = 'reader' | 'writer';

export const knowledgeManagementPermissionMapping: PermissionMapping<KnowledgeManagementPermission>[] = [
  // Knowledge Bases section
  {
    permissionSetMapping: {
      reader: ['knowledge-management-reader', 'knowledge-management-admin'],
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases',
    showInNavbar: true,
    label: 'Knowledge Bases'
  },
  // Add New Knowledge Base section
  {
    permissionSetMapping: {
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases/add',
    showInNavbar: false,
    label: 'Add Knowledge Base'
  },
  // Edit Knowledge Base section
  {
    permissionSetMapping: {
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases/*/edit',
    showInNavbar: false,
    label: 'Edit Knowledge Base'
  },
  // Edit Article section
  {
    permissionSetMapping: {
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases/*/articles/*/edit',
    showInNavbar: false,
    label: 'Edit Article'
  },
  // Compare Article Versions section
  {
    permissionSetMapping: {
      reader: ['knowledge-management-reader', 'knowledge-management-admin'],
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases/*/articles/*/compare',
    showInNavbar: false,
    label: 'Compare Article Versions'
  },
  // Article Detail (individual article view)
  {
    permissionSetMapping: {
      reader: ['knowledge-management-reader', 'knowledge-management-admin'],
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases/*/articles/*',
    showInNavbar: false,
    label: 'Article Detail'
  },
  // Knowledge Base Detail (individual KB view)
  {
    permissionSetMapping: {
      reader: ['knowledge-management-reader', 'knowledge-management-admin'],
      writer: ['knowledge-management-admin']
    },
    urlSignature: '/knowledge-bases/*',
    showInNavbar: false,
    label: 'Knowledge Base Detail'
  }
];

export default knowledgeManagementPermissionMapping;
